import { createActions } from "reduxsauce";

const { Types, Creators } = createActions(
  {
    login: ["username", "password"],
    loginLoading: null,
    loginSuccess: ["res"],
    loginFailure: ["error"],

    verifyOktaAccountSuccess: ["res"],
    verifyOktaAccountLoading: null,
    verifyOktaAccount: ["username", "password"],
    verifyOktaAccountFailure: ["error"],

    changePassword: ["email", "currentpassword", "password"],
    changePasswordLoading: null,
    changePasswordSuccess: ["res"],
    changePasswordFailure: ["error"],

    emailLogin: ["oldId", "password", "newId"],
    emailLoginLoading: null,
    emailLoginSuccess: ["res"],
    emailLoginFailure: ["error"],

    socialLogin: ["email"],
    socialLoginLoading: null,
    socialLoginSuccess: ["res"],
    socialLoginFailure: ["error"],

    loginAuth: ["sessionToken", "userId"],
    loginAuthLoading: null,
    loginAuthSuccess: ["res"],
    loginAuthFailure: ["error"],

    loginWithProxyPdn: ["proxyPdn"],
    loginWithProxyPdnLoading: null,
    loginWithProxyPdnSuccess: ["res"],
    loginWithProxyPdnFailure: ["error"],

    loginHeroku: ["id_token"],
    loginHerokuLoading: null,
    loginHerokuSuccess: ["res"],
    loginHerokuFailure: ["error"],

    setupBiometricsConsent: ["res"],

    loginWithToken: ["refresh_token"],
    loginWithTokenLoading: null,
    loginWithTokenSuccess: ["res"],
    loginWithTokenFailure: ["error"],

    loginTokenExchange: ["code"],
    loginTokenExchangeLoading: null,
    loginTokenExchangeSuccess: ["res"],
    loginTokenExchangeFailure: ["error"],

    register: ["donor"],
    registerLoading: null,
    registerSuccess: ["res"],
    registerFailure: ["error"],

    saveSignUp: ["user"],
    saveCreateProfile: ["profile"],

    logout: ["authToken", "forceLogout"],
    logoutTimeout: null,
    logoutLoading: null,
    logoutSuccess: ["res", "forceLogout"],
    logoutFailure: ["error"],

    getSession: null,
    getSessionLoading: null,
    getSessionSuccess: ["res"],
    getSessionFailure: ["error"],

    getSessionUser: null,
    getSessionUserLoading: null,
    getSessionUserSuccess: ["res"],
    getSessionUserFailure: ["error"],

    getLoggedInUser: null,
    getLoggedInUserLoading: null,
    getLoggedInUserSuccess: ["res"],
    getLoggedInUserFailure: ["error"],

    sessionRefresh: null,
    sessionRefreshLoading: null,
    sessionRefreshSuccess: ["res"],
    sessionRefreshFailure: ["error"],

    verifyEmail: ["recoveryToken", "digitalId", "sfid"],
    verifyEmailLoading: null,
    verifyEmailSuccess: ["res"],
    verifyEmailFailure: ["error"],

    changeDefaultCenter: ["userSfid", "center"],
    changeDefaultCenterLoading: null,
    changeDefaultCenterSuccess: ["res"],
    changeDefaultCenterFailure: ["error"],

    updateAccountSetting: ["userAccountSettings"],
    updateAccountSettingLoading: null,
    updateAccountSettingSuccess: ["res"],
    updateAccountSettingFailure: ["error"],

    mergeAccountSetting: ["mergeAccountSettings"],
    mergeAccountSettingLoading: null,
    mergeAccountSettingSuccess: ["res"],
    mergeAccountSettingFailure: ["error"],

    resendVerification: ["resendVerifications"],
    resendVerificationLoading: null,
    resendVerificationSuccess: ["res"],
    resendVerificationFailure: ["error"],

    resetPassword: ["email"],
    resetPasswordLoading: null,
    resetPasswordSuccess: ["res"],
    resetPasswordFailure: ["error"],

    resetPassword2: ["token"],
    resetPassword2Loading: null,
    resetPassword2Success: ["res"],
    resetPassword2Failure: ["error"],

    resetPassword3: ["stateToken", "password"],
    resetPassword3Loading: null,
    resetPassword3Success: ["res"],
    resetPassword3Failure: ["error"],

    setupNewPassword: ["flowType", "token", "password", "sfid"],
    setupNewPasswordLoading: null,
    setupNewPasswordSuccess: ["res"],
    setupNewPasswordFailure: ["error"],

    clearMigrationValues: null,
    cleanUserState: null,

    userNotifications: ["res"],

    enrollMfa: ["userId", "mfaPayload"],
    enrollMfaLoading: null,
    enrollMfaSuccess: ["res"],
    enrollMfaFailure: ["error"],

    resendEnrollMfaCode: ["userId", "mfaPayload"],
    resendEnrollMfaCodeLoading: null,
    resendEnrollMfaCodeSuccess: ["res"],
    resendEnrollMfaCodeFailure: ["error"],

    sendMfaCode: ["userId", "factorType"],
    sendMfaCodeLoading: null,
    sendMfaCodeSuccess: ["res"],
    sendMfaCodeFailure: ["error"],

    verifyMfaCode: ["userId", "passCode", "factorActivationId"],
    verifyMfaCodeLoading: null,
    verifyMfaCodeSuccess: ["res"],
    verifyMfaCodeFailure: ["error"],

    getEnrolledMfaList: ["userId"],
    getEnrolledMfaListLoading: null,
    getEnrolledMfaListSuccess: ["res"],
    getEnrolledMfaListFailure: ["error"],

    authenticateMfaCode: ["userId", "passCode", "factorType"],
    authenticateMfaCodeLoading: null,
    authenticateMfaCodeSuccess: ["res"],
    authenticateMfaCodeFailure: ["error"],
  },
  { prefix: "USERS_" }
);

export const UsersTypes = Types;

export default Creators;
